import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type { LabourUnitsResult } from 'modules/timeoff/hooks/useLabourUnits'
import type Allowance from 'modules/timeoff/store/models/Allowance'

interface Props {
  allowance?: Allowance
  admin?: boolean
  labourUnits: LabourUnitsResult
}

const FranceCalendarWarnings = ({ allowance, admin, labourUnits }: Props) => {
  const frenchCalendar = allowance?.frenchCalendarDays

  if (!frenchCalendar) return <></>

  const showWarning = labourUnits.enableFrenchCalendarFlag

  if (!showWarning) return <></>

  const text = admin
    ? i18n.t('time_off.allowances.modal.french_calendar_warning.admin')
    : i18n.t('time_off.allowances.modal.french_calendar_warning.non_admin')

  return (
    <Box
      background="champagne400"
      borderRadius={{
        all: 'abs008',
      }}
      textAlign="center"
      paddingX="s24"
      paddingY="s16"
    >
      <Text.Normal>{text}</Text.Normal>
    </Box>
  )
}

export default observer(FranceCalendarWarnings)
